"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const red = {
    100: "#6c251c",
    90: "#97291e",
    80: "#b8251b",
    70: "#de1214",
    60: "#f43531",
    50: "#ff5d5c",
    40: "#ff8681",
    30: "#fdaaa5",
    20: "#fbc9c6",
    10: "#fae1e0",
    0: "#faefee",
};
exports.default = red;
//# sourceMappingURL=red.js.map